var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.unreceivedNum !== 0,
          expression: "unreceivedNum !== 0"
        }
      ],
      staticClass: "unreceive-bubble __pointer"
    },
    [
      _vm._v("\n    " + _vm._s(_vm.unreceivedNum) + "\n    "),
      _c("tooltips", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLogin && !_vm.isShowBubble,
            expression: "!isLogin && !isShowBubble"
          }
        ],
        staticClass: "fee-tips",
        attrs: { content: _vm.$t("hint.unreceived") }
      }),
      _vm._v(" "),
      _c(
        "tooltips",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowBubble,
              expression: "isShowBubble"
            }
          ],
          staticClass: "fee-tips bubble",
          attrs: {
            content: _vm.$t("hint.unreceivedNum", { number: _vm.unreceivedNum })
          }
        },
        [_vm._v(">")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }